import { render, staticRenderFns } from "./MspAppBar.vue?vue&type=template&id=3396b948"
import script from "./MspAppBar.vue?vue&type=script&lang=js"
export * from "./MspAppBar.vue?vue&type=script&lang=js"
import style0 from "./MspAppBar.vue?vue&type=style&index=0&id=3396b948&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports